import { SystemUsersRoute } from "pages/SystemUsers/routes";
import { AuditLogsRoute } from "pages/AuditLogs/routes";
import { DefaultSeoRoute } from "pages/DefaultSeo/routes";
import { SitemapRoute, RobotsRoute } from "pages/Sitemap/routes";
import { GeneralPageRoute } from "pages/General/routes";
import { MallRoute } from "pages/Mall/routes";
import { BrandsRoute } from "pages/BrandsListing/routes";
import { BrandsMainPageRoute } from "pages/BrandsMainPage/routes";
import { PremiumMainPageRoute } from "pages/Premium/routes";
import { FoodMainPageRoute } from "pages/Food/routes";
import { BrandsCategoriesRoute } from "pages/BrandCategories/routes";
import { OffersRoute } from "pages/OffersListing/routes";
import { OffersMainPageRoute } from "pages/OffersMainPage/routes";
import { VacancyRoute } from "pages/VacancyListing/routes";
import { VacancyMainPageRoute } from "pages/VacancyMainPage/routes";
import { NewsRoute } from "pages/NewsListing/routes";
import { NewsMainPageRoute } from "pages/NewsMainPage/routes";
import { CashbackRoute } from "pages/CashbackListing/routes";
import { CashbackMainPageRoute } from "pages/CashbackMainPage/routes";
import { ServicesRoute } from "pages/ServiceListing/routes";
import { ServicesMainPageRoute } from "pages/ServicesMainPage/routes";
import { ReviewsRoute } from "pages/ReviewsListing/routes";
import { ReviewsMainPageRoute } from "pages/ReviewsMainPage/routes";
import { CardsRoute } from "pages/GiftCardListing/routes";
import { CardsMainPageRoute } from "pages/GiftCardMainPage/routes";
import { CityMallCardPageRoute } from "pages/CityMallCard/routes";
import { LoyaltyCardsRoute } from "pages/LoyaltyCard/routes";
import { MapMainPageRoute } from "pages/MapMainPage/routes";
import { MapFloorRoute } from "pages/MapFloors/routes";
import { MapPinRoute } from "pages/MapPins/routes";
import { HomepageEventsRoute } from "pages/HomepageEvents/routes";
import { SpecialEventRoute } from "pages/SpecialEvent/routes";
import { homeMainPageRoute } from "pages/HomeMainPage/routes";
import { HomePageSliderRoute } from "pages/HomepageSlider/routes";
import { HomepageBrandsRoute } from "pages/HomepageBrands/routes";
import { LandingPageRoute } from "pages/LandingPage/routes";
import { ContactPageRoute } from "pages/Contact/routes";
import { LoyaltyBenefitsRoute } from "pages/LoyaltyBenefits/routes";
import { TermsAndConditionsPageRoute } from "pages/TermsAndConditions/routes";
import { LoyaltyUserTermsAndConditionsPageRoute } from "pages/LoyaltyUserTermsAndConditions/routes";
import { PrivacyPolicyPageRoute } from "pages/PrivacyPolicy/routes";
import { CookiesPolicyPageRoute } from "pages/CookiesPolicy/routes";
import { AdditionalInformationPageRoute } from "pages/AdditionalInformation/routes";
import { CityTowerPageRoute } from "pages/CityTower/routes";
import { MagicCityPageRoute } from "pages/MagicCity/routes";

// Maps each route path to the access key the backend returns in Identity/getUser.
// Multiple routes sharing the same key means one backend key grants access to all of them.
export const ROUTE_ACCESS_MAP: Record<string, string> = {
  // Admin only
  [SystemUsersRoute.path]:  "Admin",
  [AuditLogsRoute.path]:    "Admin",
  [DefaultSeoRoute.path]:   "Admin",
  [SitemapRoute.path]:      "Admin",
  [RobotsRoute.path]:       "Admin",
  [GeneralPageRoute.path]:  "Admin",
  [MallRoute.path]:        "Admin",

  // Brands
  [BrandsRoute.path]:          "Brands",
  [BrandsMainPageRoute.path]:  "Brands",
  [PremiumMainPageRoute.path]: "Brands",
  [FoodMainPageRoute.path]:    "Brands",

  // Categories
  [BrandsCategoriesRoute.path]: "Categories",

  // Offers
  [OffersRoute.path]:         "Offers",
  [OffersMainPageRoute.path]: "Offers",

  // Vacancies
  [VacancyRoute.path]:         "Vacancies",
  [VacancyMainPageRoute.path]: "Vacancies",

  // News
  [NewsRoute.path]:         "News",
  [NewsMainPageRoute.path]: "News",

  // Cashback
  [CashbackRoute.path]:         "Cashback",
  [CashbackMainPageRoute.path]: "Cashback",

  // Services
  [ServicesRoute.path]:         "Services",
  [ServicesMainPageRoute.path]: "Services",

  // Reviews
  [ReviewsRoute.path]:         "Reviews",
  [ReviewsMainPageRoute.path]: "Reviews",

  // Cards
  [CardsRoute.path]:            "Cards",
  [CardsMainPageRoute.path]:    "Cards",
  [CityMallCardPageRoute.path]: "Cards",
  [LoyaltyCardsRoute.path]:     "Cards",

  // Map
  [MapMainPageRoute.path]: "Map",
  [MapFloorRoute.path]:    "Map",
  [MapPinRoute.path]:      "Map",

  // Events
  [HomepageEventsRoute.path]: "Events",
  [SpecialEventRoute.path]:   "Events",

  // HomePage
  [homeMainPageRoute.path]:   "HomePage",
  [HomePageSliderRoute.path]: "HomePage",
  [HomepageBrandsRoute.path]: "HomePage",

  // LandingPage
  [LandingPageRoute.path]: "LandingPage",

  // ContactPage
  [ContactPageRoute.path]: "ContactPage",

  // LoyaltyBenefits
  [LoyaltyBenefitsRoute.path]: "LoyaltyBenefits",

  // Text pages
  [TermsAndConditionsPageRoute.path]:            "TermsAndConditions",
  [LoyaltyUserTermsAndConditionsPageRoute.path]: "LoyaltyTermsAndConditions",
  [PrivacyPolicyPageRoute.path]:                 "PrivacyPolicy",
  [CookiesPolicyPageRoute.path]:                 "CookiesPolicy",
  [AdditionalInformationPageRoute.path]:         "AdditionalInformation",
  [CityTowerPageRoute.path]:                     "CityTower",
  [MagicCityPageRoute.path]:                     "MagicCity",
};
